import { useEffect, useState } from "react";
import { Ban, CheckCircle2, Clock, ImageOff, XCircle } from "lucide-react";
import { api, dt, money, SEL_LABEL } from "@/lib/api";

const TONE = { pending: ["bg-amber-50 text-amber-800 border-amber-300", Clock], sold: ["bg-emerald-50 text-emerald-800 border-emerald-300", CheckCircle2],
  failed: ["bg-rose-50 text-rose-800 border-rose-300", XCircle], cancelled: ["bg-slate-100 text-slate-600 border-slate-300", Ban] };

export const SelectionBadge = ({ s, testid = "selection-status" }) => {
  const [cls, Icon] = TONE[s] || TONE.pending;
  return <span data-testid={testid} className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-bold border whitespace-nowrap ${cls}`}><Icon className="w-3.5 h-3.5" /> {SEL_LABEL[s]}</span>;
};

function AuthImg({ src, onOpen }) {
  const [url, setUrl] = useState(null);
  const [bad, setBad] = useState(false);
  useEffect(() => {
    let u = null, alive = true;
    api.get(src, { responseType: "blob", timeout: 60000 }).then((r) => { u = URL.createObjectURL(r.data); if (alive) setUrl(u); }).catch(() => alive && setBad(true));
    return () => { alive = false; if (u) URL.revokeObjectURL(u); };
  }, [src]);
  if (bad) return <div className="w-24 h-24 rounded-xl bg-slate-100 grid place-items-center text-slate-400"><ImageOff className="w-6 h-6" /></div>;
  if (!url) return <div className="w-24 h-24 rounded-xl bg-slate-100 animate-pulse" />;
  return <button type="button" onClick={() => onOpen(url)} className="block"><img src={url} alt="" className="w-24 h-24 rounded-xl object-cover border" data-testid="selection-photo" /></button>;
}

export function SelectionPhotos({ sel }) {
  const [big, setBig] = useState(null);
  if (!sel.photos?.length) return <div className="text-sm text-slate-500" data-testid="no-photos">لا توجد صور</div>;
  return (
    <>
      <div className="flex flex-wrap gap-2" data-testid="selection-photos">
        {sel.photos.map((p) => <AuthImg key={p.id} src={`/selections/${sel.id}/photos/${p.id}`} onOpen={setBig} />)}
      </div>
      {big && <div className="fixed inset-0 z-[100] bg-black/80 grid place-items-center p-4" onClick={() => setBig(null)} data-testid="photo-viewer"><img src={big} alt="" className="max-h-[90vh] max-w-full rounded-xl" /></div>}
    </>
  );
}

export function SelectionInfo({ sel }) {
  const rows = [["رقم السجل", sel.number], ["رقم الكبش", sel.ear_tag], ["القسم", `${sel.section_code} – ${sel.section_name}`], ["السعر المتفق عليه", money(sel.price)],
    ["العامل المشرف على الاختيار", sel.worker_name], ["سجّله", sel.created_by_name], ["تاريخ ووقت الاختيار", dt(sel.selected_at)]];
  if (sel.sale_number) rows.push(["عملية البيع", sel.sale_number], ["موظف المكتب الذي أكد البيع", sel.clerk_name]);
  if (sel.status_reason) rows.push(["السبب", `${sel.status_reason} (${sel.status_by})`]);
  return (
    <div className="space-y-3" data-testid="selection-info">
      <SelectionBadge s={sel.status} />
      <dl className="grid grid-cols-2 gap-y-2 text-sm">
        {rows.map(([k, v]) => <div key={k} className="contents"><dt className="text-slate-500">{k}</dt><dd className="font-bold">{v}</dd></div>)}
      </dl>
      {sel.notes && <div className="rounded-xl bg-[#F6F1E7] p-3 text-sm"><b>ملاحظات: </b>{sel.notes}</div>}
      <SelectionPhotos sel={sel} />
    </div>
  );
}
